import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as BurgerIcon } from 'assets/burger.svg';

const TopbarSidebarButton = ({
  changeMobileSidebarVisibility,
  // changeSidebarVisibility,
  iconColor,
}) => (
  <div>
    {/* <button
      type="button"
      className="topbar__button topbar__button--desktop"
      onClick={changeSidebarVisibility}
    >
      <BurgerIcon className="topbar__button-icon" fill={iconColor} />
    </button> */}
    <button
      type="button"
      className="topbar__button topbar__button--mobile"
      onClick={changeMobileSidebarVisibility}
    >
      <BurgerIcon className="topbar__button-icon" fill={iconColor} />
    </button>
  </div>
);

TopbarSidebarButton.propTypes = {
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
  // changeSidebarVisibility: PropTypes.func.isRequired,
  iconColor: PropTypes.string.isRequired,
};

export default TopbarSidebarButton;
